/* c080 scoped approved announcement controller. */
(function(){
/** Announcement controller: every query stays inside the supplied announcement root. */
function initAnnouncement(root) {
 const bar=root.querySelector('.bm-announcement');
 if(!bar || bar.dataset.initialized) return;
 const more=bar.querySelector('.bar-more'), close=bar.querySelector('.bar-close'), details=bar.querySelector('.bar-details');
 if(!more || !close || !details) return;
 bar.dataset.initialized='true';
 function setOpen(open,focus=true) {
  more.setAttribute('aria-expanded',String(open));
  details.hidden=!open;
  bar.classList.toggle('is-open',open);
  if(focus) (open?close:more).focus();
 }
 more.addEventListener('click',()=>setOpen(true));
 close.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();setOpen(false);});
 bar.addEventListener('keydown',event=>{
  if(event.key==='Escape' && more.getAttribute('aria-expanded')==='true') { event.preventDefault(); setOpen(false); }
 });
 // Resizing to desktop must not leave a phone-only focus target active or reopen stale disclosure later.
 const desktop=window.matchMedia('(min-width:768px)');
 desktop.addEventListener('change',()=>{
  if(desktop.matches) setOpen(false,false);
 });
}

/** Phone promo, 15 Oct: one line that scrolls sideways in its own column. The fade follows the scroll position, and data-fade is written only when the state changes. */
const promoSeen=new WeakSet();
function initPromoScroll(bar) {
 bar.querySelectorAll('.bar-phone .bar-promo').forEach(box=>{
  if(promoSeen.has(box)) return;
  promoSeen.add(box);
  let frame=0, down=null;
  const update=()=>{
   frame=0;
   const max=box.scrollWidth-box.clientWidth, x=Math.abs(box.scrollLeft);
   const left=max>1 && x>1, right=max>1 && x<max-1;
   const state=left?(right?'both':'left'):(right?'right':'none');
   if(box.dataset.fade!==state) box.dataset.fade=state;
  };
  const queue=()=>{ if(!frame) frame=requestAnimationFrame(update); };
  box.addEventListener('scroll',queue,{passive:true});
  if(window.ResizeObserver) { const watch=new ResizeObserver(queue); watch.observe(box); box.querySelectorAll('.bar-promo-line1').forEach(line=>watch.observe(line)); }
  if(document.fonts) document.fonts.ready.then(queue);
  queue();
  // Keyboard focus brings the start of the message back into view.
  box.addEventListener('focusin',event=>{
   let keyboard=false;
   try { keyboard=event.target.matches(':focus-visible'); } catch(error) {}
   if(keyboard && box.scrollLeft) box.scrollLeft=0;
  });
  // A pan that moved the message is not a tap, even where a browser still sends the click.
  // Capture phase: the theme's page-transition listener on every link navigates by script and ignores preventDefault.
  box.addEventListener('pointerdown',()=>{ down={x:box.scrollLeft,t:Date.now()}; },{passive:true});
  box.addEventListener('click',event=>{
   if(down && Date.now()-down.t<1500 && Math.abs(box.scrollLeft-down.x)>4) { event.preventDefault(); event.stopPropagation(); }
   down=null;
  },true);
 });
}

 function init(root){ root.querySelectorAll('.bm-announcement').forEach(bar=>{ initAnnouncement(bar.parentElement); initPromoScroll(bar); }); }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
